import React from "react";
import { Button } from "reactstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { getSubscriptionStatus } from "../utils/helper";
import { config } from "../utils/config";
function VariationCountPopup({ close }) {
  const navigate = useNavigate();
  let planDetails;
  let variantDetails;
  const userPlanRaw = localStorage.getItem(config.USER_PLAN_DETAILS);
  if (userPlanRaw && userPlanRaw !== "undefined" && userPlanRaw !== "null") {
    planDetails = JSON.parse(userPlanRaw);
  }

  const variantRaw = localStorage.getItem(config.VARIANT_COUNT);
  if (variantRaw && variantRaw !== "undefined" && variantRaw !== "null") {
    variantDetails = JSON.parse(variantRaw);
  }
  let remainCounts =
    +planDetails?.plan_id == 5
      ? variantDetails?.remaning
      : 20 - planDetails?.variant_count;
  return (
    <>
      <div className="success_bg">
        <div className="success_content">
          <NavLink to={""} onClick={() => close()}>
            <img src="/assets/images/disablecross.svg" className="crossicon" alt="" />
          </NavLink>

          <img src="/assets/images/verify.svg" className="verify_img" alt="" />

          <div className="row">
            <div className="text-center mb-4">
              <a className="red-background mb-5">Subscription Alert</a>
            </div>
            <div className="justify-content-center text-center">
              <h2>{getSubscriptionStatus(planDetails)}</h2>

              <p
                style={{
                  color: "#433a3a",
                  fontSize: "14px",
                  width: "70%",
                  margin: "0 auto",
                }}
              >
                Get started with Teedex's free plan! Create up to 20 stunning
                variations and experience the power of Auto customization. Start
                designing today!
              </p>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="justify-content-center text-center">
              {remainCounts > 0 ? (
                <Button color="create_variations mb-3" onClick={() => close()}>
                  Create {remainCounts} Free Variations
                </Button>
              ) : (
                <Button
                  color="create_variations mb-3"
                  onClick={() => navigate("/plans")}
                >
                  Upgrade Now
                </Button>
              )}

              {/* <p>
                Want to upgrade to Unlimited Plan?{" "}
                <NavLink to={"/plans"}>Upgrade now2</NavLink>
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default VariationCountPopup;
